import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReasonComponent } from './simple-icons-reason.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReasonComponent ],
    exports:      [ SimpleIconsReasonComponent ],
    bootstrap:    []
})
export class SimpleIconsReasonModule {}
